import { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { isEqual } from 'lodash';

import { Condition, Iteration } from 'Component/others';

import { weeks } from 'View/schedule-generate/const';
import Dropzone from 'View/schedule-generate/component/dropzone';
import HostCard from 'View/schedule-generate/component/host-card';
import checkIsEventDay from 'View/schedule-generate/helper/checkIsEventDay';

import styles from './styles.module.css';

const CalendarHour = ({ showWeek, lastDate, hour, datas, hoursInfo, metadata }) => {
  const { hoursEventDay, hoursNormalDay, agencyNormalHours, agencyPaydayHours } = hoursInfo;

  return (
    <Box className={styles['calendar__column--days']}>
      <Iteration
        items={weeks}
        render={(week) => {
          const day = (showWeek - 1) * 7 + week + 15;
          const isDayInMonth = day <= lastDate;
          const date = isDayInMonth ? day : day - lastDate;
          const isInsidePeriod = (isDayInMonth && date >= 16) || (!isDayInMonth && date <= 15);
          const location = [date, hour.hours];
          const schedules = datas?.find((data) => data.week === showWeek)?.schedules || [];
          const hosts = schedules.filter((schedule) => isEqual(location, schedule.location));
          const isEventDay = checkIsEventDay(metadata, date);
          const liveHours = isEventDay ? hoursEventDay : hoursNormalDay;
          const isLiveHours = hour.hours >= liveHours[0] && hour.hours < liveHours[1];

          const agencyHours = isEventDay && agencyPaydayHours && agencyNormalHours ? agencyPaydayHours : agencyNormalHours;

          const isAgencyLiveHours = agencyHours?.length && hour.hours >= agencyHours[0] && hour.hours < agencyHours[1] && isInsidePeriod;

          const isDisabled = !isInsidePeriod || !isLiveHours || isAgencyLiveHours;

          return (
            <Box className={`${styles['calendar__box--dropzone']} ${isDisabled && !isAgencyLiveHours && styles['calendar__box--dropzone-disable']}`}>
              <Dropzone location={location} isDisabled={isDisabled} schedules={schedules}>
                {/* Agency */}
                <Condition statement={isAgencyLiveHours}>
                  <HostCard location={location} isAgency={true} cardWidth={'100%'} />
                </Condition>

                {/* Host */}

                <Condition statement={hosts.length}>
                  <Iteration
                    items={hosts}
                    render={(host, indexHost) => {
                      const totalHost = hosts?.length;
                      const gap = ((totalHost - 1) * 4) / totalHost;
                      const cardWidth = `calc(${100 / totalHost}% - ${gap}px)`;

                      return <HostCard cardWidth={cardWidth} location={location} key={indexHost} host={host} />;
                    }}
                  />
                </Condition>
              </Dropzone>
            </Box>
          );
        }}
      />
    </Box>
  );
};

const MemoizedCalendarHour = (props) => {
  return useMemo(() => <CalendarHour {...props} /> /* eslint-disable */, [props]);
};

export default MemoizedCalendarHour;
